<template>
  <div class="ui-chess-legends">
    <template v-if="!loading">
      <div
        class="ui-chess-legends-item"
        v-for="(legend, i) in legends"
        :key="`legend-${i}`"
      >
        <ui-chess-item
          :room="legend"
          :has-grades="hasGrades"
          only-status
        />
        <span class="ui-chess-legends-item__description">{{ legend.description }}</span>
      </div>
    </template>
    <template v-else>
      <div
        class="ui-chess-legends-item"
        v-for="i in loadingNumber"
        :key="`loading-${i}`"
      >
        <ui-skeleton
          :height="38"
          :width="38"
          :border-radius="2"
        />
        <ui-skeleton
          class="ui-chess-legends-item__description"
          :height="14"
          :width="100"
        />
      </div>
    </template>
  </div>
</template>

<script>
import UiChessItem from './UiChessItem.vue'
import UiSkeleton from '../skeleton/UiSkeleton.vue'

export default {
  components: { UiChessItem, UiSkeleton },
  props: {
    legends: Array,
    hasGrades: Boolean,
    loadingNumber: {
      type: Number,
      default: 6
    },
    loading: Boolean
  }
}
</script>

<style lang="scss" scoped>
.ui-chess-legends {
  display: flex;
  gap: 24px 32px;
  flex-wrap: wrap;
  border-top: 1px solid #EBECEE;

  &-item {
    display: flex;
    align-items: center;

    &__description {
      margin-left: 24px;
    }
  }
}
</style>
